export function scrollLeaderboardItemIntoView(athleteId: string, place?: string | number | JSX.Element | null) {
    const actionArea = document.querySelector("#pending-leaderboard-action-area");
    const leaderboardItem = document.querySelector(place && place !== "-" ? `[data-place="${place}"]` : `[data-athlete="${athleteId}"]`);

    if (!actionArea || !leaderboardItem) return;
    
    const actionAreaEdge = actionArea.getBoundingClientRect().bottom;
    const selectedPlaceEdge = leaderboardItem.getBoundingClientRect().top;

    window.scrollBy({ top: selectedPlaceEdge - actionAreaEdge - 16, behavior: "smooth" });
}
